import { ICamera } from "@/store/views/types";
import { AlarmQueueFilterID, AlarmQueueFilter } from "@/store/eventqueue/types";
import { ILayer } from "@sureview/v2-mapping";
import MobileInfoWindow from "@/components/mobile/core/MobileInfoWindow.vue";

import {
	ILatLng
} from "@sureview/v2-mapping";
import {
	Guard, PatrolZone, DispatchableEvent
} from "@sureview/v2-dispatch";

export interface Mobile {
	MobileUser: {
		showDirections: boolean;
		manualLocationUpdate: boolean;
	},
	DispatchGuard: {
		guardId: number | null;
		onDuty: boolean;
		isCoverAvailable: boolean;
		callSign: string;
		originalCallSign: string;
		unavailableReason: string;
		unavailableStatusId: number;
		isRightSideBarOpen: boolean;
		isLeftSideBarOpen: boolean;
		almostArrived: boolean;
		hasArrived: boolean;
		status: string;
		statusEnum: GuardStatus;
		currentTourStepIdentifier: string;
	};
	CallSigns: Guard[];
	CoverCallSigns: Guard[];
	CoverRequested: boolean;
	CoverRequest?: Guard;
	LeftSidebar: LeftSidebar;
	ProximityCallSigns: Guard[];
	DeviceLocation: any;
	IsWatchingLocation: boolean;
	DispatchRequests: DispatchRequest[];
	FocalPoint: any;
	AuditEndpoint: string;
	MobileFeatures: MobileFeatures;
	DispatchNotesForEvent: DispatchNote[];
	MobileGuardsForEvent: Guard[];
	UnavailableStatuses: UnavailableStatus[];
	LiveDevice: ICamera;
	MobileMode: string;
	MainComponentName: string;
	RightComponentName: string;
	MapEnabled: boolean;
	StarredDevices: StarredDevice[];
	NotificationText: string;
	ManageDataLoading: boolean;
	ManageGuards: Guard[];
	ManagePatrolZones: PatrolZone[],
	ManageEvents: DispatchableEvent[];
	ManageAlarmQueueFilters: AlarmQueueFilter[];
	ManageCurrentAlarmQueueFilters: AlarmQueueFilter[];
	MapGoto: (latLng: ILatLng) => void;
	QuickCloseList: QuickClose[];
	CurrentTour: any; /* FIXME ADD TYPE GuardTour;*/
	PatrolZones: PatrolZone[];
	UserSharedEventIds: number[];
}

export interface DispatchRequest {
	dispatchQueueID: number;
	preferredGuardID: number | null;
	patrolZoneID: number | null;
	created: any;
	eventID: number | null;
	requester: string;
	requesterDescription: string;
	guardID: number;
	active: boolean;
	claimed: boolean;
	location: any;
	eventDetails: string;
	serverTypeEventTitle: string;
	areaTitle: string;
	dispatchType: string;
	objectId: number | null;
	isCurrentTourStep: boolean | null;
	isIncidentCommander: boolean;
	incidentCommanderCallsign: string;
	guardTourId?: number | null;
}

export interface Guard {
	guardID?: number | null;
	callsign: string;
	originalCallSign: string;
	dispatchGuardTypeID?: number | null;
	lastLocation?: string;
	status?: GuardStatus;
	alarmQueueFilterID?: number | null;
	alarmQueueFilterTitle?: string;
	patrolZones: {
		[patrolZoneID: string]: string;
	};
	attendingEventID?: number | null;
	userID?: number | null;
	unavailableStatusID?: number | null;
	unavailableReason: string | null;
	active?: boolean | null;
	claimed?: boolean | null;
	eventID?: number | null;
}

export interface DispatchNote {
	DateTime: string;
	Note: string;
	noteType: NoteType;
}

export enum NoteType {
	Guard = 0,
	Operator = 1
}

export interface MobileFeatures {
	isManualRaiseEnabled: boolean;
	isSOSEnabled: boolean;
	isLostModeEnabled: boolean;
	isBreakCoverEnabled: boolean;
	isClaimedEnabled: boolean;
	isFileUploadEnabled: boolean;
}

export interface UnavailableStatus {
	statusID: number;
	name: string;
}

export enum GuardStatus {
	Available = 1,
	Dispatched = 2,
	Arrived = 3,
	Unavailable = 4,
	EnRoute = 5,
	Covered = 8,
	Covering = 9,
	CoveringRequested = 10
}

export interface StarredDevice {
	deviceID: number;
	title: string;
	area: string;
}

export interface SVLocation {
	lat: number;
	lng: number;
}
export interface MobileMarker {
	id: number,
	title: string,
	location: google.maps.LatLng,
	iconURL: string,
	color: string,
	infoWindow: MobileInfoWindow,
	googleMarker: google.maps.Marker,
	object: object
}

export interface QuickClose {
	eventOutcomeID: number;
	title: string;
	isMobileClose: boolean;
	groupID: number;
	displayTitle: string;
}

export interface ScannerCheckInLocation {
	Latitude: number;
	Longitude: number;
}

export interface ScannerCheckInPayload {
	Cancelled?: boolean;
	Location?: ScannerCheckInLocation;
	Error: string;
	Identifier: string;
}

export interface GuardCheckInPayload {
	locationIdentifier: string;
	eventId: number;
	guardId: number;
}

export interface GuardTourCheckInPayload {
	locationIdentifier: string;
	eventId: number;
	guardId: number;
	guardTourStepId: number;
}

export interface GuardCheckInResponse {
	latLong: string;
	minElevation: number;
	maxElevation: number;
	isCorrectLocation: boolean;
}

export interface GuardCheckedInLocation {
	location: google.maps.LatLng;
	minElevation: number;
	maxElevation: number;
	isCorrectLocation: boolean;
}

export interface MapBounds {
	north: number;
	south: number;
	east: number;
	west: number;
	elevation: number;
}

export interface ILayerMap {
	[layerId: number]: ILayer;
}

export enum DispatchType {
	Tour = "Tour",
	Dispatch = "Dispatch",
	Assessment = "Assessment"
}

export enum DispatchGuardType {
	Roaming = 1,
	Static = 2,
	Fox = 3,
	Mobile = 4,
	Assessor = 100,
}

export enum DeviceType {
	Unknown = 0,
	LegacyiOS = 1,
	LegacyAndroid = 2,
	CCiOS = 3,
	CCAndroid = 4,
}

export interface TrackingToggle {
	toggle: string;
}

export interface ScanType {
	type: string;
}

export interface WebAppInterface {
	// IMPORTANT: Android WebAppInterfaces can only take primitive types as a parameter
	trackingRequest(trackingToggle: string) : void;
	scanRequest(type: string) : void;
}

export interface LeftSidebar {
	UnavailablePickerShown : boolean,
	CoverPickerShown: boolean,
	HasCoverRequest: boolean
}

export interface MobileGuardsRequest {
	EventID: number,
	Location: string,
	IncludeGuardsWithMatchingFilter: boolean
}

export interface RaiseDuressEvent {
	latitude: number;
	longitude: number;
}

export interface RaiseDuressEventResponse {
	successful: boolean | null;
	error: string | null;
}